'use client'

import { motion } from 'framer-motion'
import ImageWithFallback from 'src/components/ImageWithFallBack'

const DeliveryIntelligenceSection = () => {
  const statsData = [
    {
      src: '/v2/images/coins.svg',

      value: '3%',
      description: 'Revenue recovered automatically',

      color: 'text-[#ffc542]',
      bgColor: 'bg-gradient-to-t from-amber-50 to-white'
    },
    {
      src: '/v2/images/bars.svg',
      value: '25%',
      description: 'Sales growth from smarter marketing spend',
      color: 'text-[#3366ff]',
      bgColor: 'bg-gradient-to-t from-purple-50 to-white'
    },
    {
      src: '/v2/images/cards.svg',
      value: '20h',
      description: 'Saved per store, every month on reconciliation',
      color: 'text-[#28c76f]',
      bgColor: 'bg-gradient-to-t from-green-50 to-white'
    },
    {
      src: '/v2/images/toggle.svg',
      value: '99.6%',
      description: 'Uptime for your customers',
      color: 'text-[#28c76f]',
      bgColor: 'bg-gradient-to-t from-green-50 to-white'
    }
  ]

  return (
    <motion.section
      data-item="delivery-intelligence-section"
      className="py-10 sm:py-16 md:py-24 bg-white relative mb-10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}>
      <div className="container mx-auto px-4 md:px-8 flex flex-col items-center w-full relative z-10">
        <motion.h2
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mt-0 mb-10 sm:mb-16 md:mb-24 text-[#0a1734] w-full md:w-3/4 text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}>
          Save on errors, downtimes & reporting with Delivery Intelligence
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-6 mb-12 p-6 sm:p-0">
          {statsData.map((stat, i) => (
            <motion.div
              key={i}
              className={`shadow-md p-1 pt-5 sm:pt-5 ${stat.bgColor} outline
              outline-1 outline-gray-200 rounded-3xl relative z-10 `}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 + i * 0.1 }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}>
              <div className="flex flex-col px-8 md:px-4 mt-8 sm:mt-0">
                <span className="text-lg text-gray-900 mb-2 mt-10">Up to</span>
                <h3 className={`text-6xl  sm:text-7xl  text-[#0a1734] `}>
                  {stat.value}
                </h3>
                <p className="text-gray-500 my-4 md:my-6 min-h-32 sm:min-h-32 text-lg h-18 md:h-16 line-clamp-3">
                  {stat.description}
                </p>
              </div>
              <div
                className={`h-64 sm:h-64 rounded-lg flex items-end justify-center px-4 py-1`}>
                <ImageWithFallback
                  src={stat.src || ''}
                  alt="Delivery Intelligence"
                  className="w-full h-full object-contain"
                  width={100}
                  height={100}
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Backdrop Image */}
      <div
        className="absolute -bottom-10 left-0 right-0 w-full h-[72px] bg-repeat-x -z-0 -mb-1"
        style={{
          backgroundImage:
            'url(/v2/images/deliveryIntelligenceSectionBackdrop.svg)',
          backgroundPosition: 'center bottom'
        }}
      />
    </motion.section>
  )
}

export default DeliveryIntelligenceSection
